<script setup>
import {computed} from "vue";
import AlreadyConnectedTag from "@/components/google/partials/AlreadyConnectedTag.vue";

const props = defineProps({
  value: {
    required: true,
    type: [Boolean, String, Number],
  },
  title: {
    required: true,
    type: String,
  },
  alreadyConnected: {
    type: Boolean,
    default: false,
  },
})

const model = defineModel({
  type: [String,Number],
});

const active = computed(() => model.value === props.value);

const onClick = () => {
  model.value = active.value ? undefined : props.value;
}
</script>

<template>
  <div
    class="tw-p-4 md:tw-p-6 lg:tw-p-8 tw-border-2 tw-rounded-xl tw-flex tw-gap-4 tw-cursor-pointer tw-transition-all tw-group tw-items-start"
    :class="[
      active ? 'tw-border-primary tw-bg-primary-100' : 'tw-border-neutral-300 tw-bg-white hover:tw-border-primary-200',
    ]"
    @click="onClick"
  >
    <div
      class="tw-h-6 tw-w-6 tw-border-2 tw-border-neutral-300 tw-p-1 tw-rounded-full tw-bg-white tw-flex tw-items-center tw-align-middle tw-shrink-0 tw-grow-0"
    >
      <span
        class="tw-w-full tw-h-full tw-m-0 tw-rounded-full tw-transition-all"
        :class="active ? 'tw-bg-primary' : 'tw-bg-white group-hover:tw-bg-primary-200'"
      />
    </div>

    <div class="tw-flex tw-flex-col tw-gap-2 tw-min-w-0">
      <p class="tw-text-lg tw-font-semibold tw-m-0 tw-break-words">
        {{ title }}
      </p>
      <div class="tw-text-base">
        <slot />
      </div>
      <AlreadyConnectedTag v-if="alreadyConnected" />
    </div>
  </div>
</template>
